import {
  AsyncPropSelector,
  AppContext,
  getCompanyInfoHook,
  CurrencyText,
  getPositiveValue
} from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import {
  Button,
  ButtonGroup,
  Popover,
  TextField
} from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import React, { useCallback, useState, useContext } from 'react';
import styled from 'styled-components';
import { EditIcon } from '@nile/components/src/Icons';
import { CurrencyField } from '@nile/components/src/Utils/CurrencyText';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  padding-left: 8px;
  padding-right: 8px;
  max-width: 100%;
  ${({ alignRight }) =>
    alignRight &&
    `
    width: 100%;
    justify-content: flex-end;
  `}
`;

function CurrencyCell(props) {
  const { company } = useContext(AppContext);
  const { cell, params, _ticket } = props;
  const allProps = params || cell.column;
  const { editable, field, actions, accessor, entity, editMode } = allProps;
  const currencyCode = getCompanyInfoHook()?.currency || 'USD';
  const countryCode = allProps?.countryCode || company?.countryCode || 'US';
  const ticket = _ticket || cell.row.original;
  const [popoverActive, setPopoverActive] = useState(false);
  const [updatedProperties, setUpdatedProperties] = useState({});
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });
  const activator = <EditIcon onClick={() => togglePopoverActive()} />;

  const updateSelectedProperties = (key, value) => {
    setUpdatedProperties({
      ...updatedProperties,
      [key]: value
    });
  };

  const updateSelection = (f, val) => {
    let serialisedValue = null;
    if (field.isCustom) {
      updateSelectedProperties('customFields', val);
    } else {
      switch (field.name) {
        case 'techGroup':
          serialisedValue = { groupId: val.groupId, name: val.name };
          break;
        case 'technician':
          serialisedValue = { userId: val.userId };
          break;
        case 'sop':
          serialisedValue = { sopId: val.sopId, name: val.name };
          break;
        default:
          serialisedValue = val.name;
      }
      updateSelectedProperties(field.name, serialisedValue);
    }
  };

  const getTag = () => {
    const fieldValue = updatedProperties[field.name] || ticket[field.name];
    const defaultValue = fieldValue
      ? typeof fieldValue === 'object'
        ? {
            name: fieldValue.name,
            label: fieldValue.name,
            value: fieldValue.name
          }
        : { name: fieldValue, label: fieldValue, value: fieldValue }
      : '';
    return (
      <div className="min-w-200 max-w-250 fg1 pr10 pl10 mt-8 mb8">
        <AsyncPropSelector
          defaultValue={defaultValue}
          updateSelection={updateSelection}
          ticket={ticket}
          field={field}
          entity={entity || 'Ticket'}
        />
        <div className="mt10">
          <ButtonGroup>
            <Button
              onClick={() => {
                togglePopoverActive();
                setUpdatedProperties({});
              }}
            >
              Cancel
            </Button>
            <Button
              primary
              onClick={() => {
                actions.save &&
                  actions.save(updatedProperties, ticket, props.data);
                togglePopoverActive();
                setUpdatedProperties({});
              }}
            >
              Save
            </Button>
          </ButtonGroup>
        </div>
      </div>
    );
  };

  const renderValue = (displayVal) => {
    if (cell?.column?.isBold) {
      return (
        <b>
          <CurrencyText value={displayVal} />
        </b>
      );
    }
    return <CurrencyText value={displayVal} />;
  };
  //TODO :: render value in a proper way for NA - vignesh

  const displayVal = cell?.column?.dynamicAccessor
    ? cell?.column.dynamicAccessor(cell?.row?.original)
    : cell?.value;

  // if (allProps.id === 'amount' && editMode) {
  //   const rowValue = cell.row.original;
  //   displayVal =
  //     Number(rowValue.quantity) * Number(rowValue.unitPrice) -
  //     (Number(rowValue.quantity) *
  //       Number(rowValue.unitPrice) *
  //       Number(rowValue.discountRate)) /
  //       100;
  // }

  return (
    <Wrap className={`cell`} alignRight={cell?.column?.alignRight}>
      {editable && editMode ? (
        <CurrencyField
          id="ticketStatusDescription"
          value={displayVal}
          onChange={(val) => {
            const value = getPositiveValue(val);
            actions.onChange({
              key: allProps.id,
              value: value,
              field: cell.row.original
            });
          }}
          type="number"
        />
      ) : (
        <div className="ellipsis">
          {displayVal ? renderValue(displayVal) : <DisabledTag>NA</DisabledTag>}
        </div>
      )}
    </Wrap>
  );
}

export default CurrencyCell;
